export default "__VITE_ASSET__7d5f70c0__$_?nuxt_component=async__"